import React, { useState, useEffect } from "react";
import DeleteModal from "./Assets/DeleteModal";
import { TbEdit } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";



const Department = ({ isSidebarCollapsed }) => {
  const [Departments, setDepartments] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
  });
    const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  
  const Auth = localStorage.getItem("authToken");
  
useEffect(() => {
  fetchDepartments();
}, []);

  const fetchDepartments = async () => {
  try {
    const response = await fetch("https://backend.sanchalansetu.com/api/v1/departments/list", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${Auth}`
      },
    });

    if (!response.ok) throw new Error("Failed to fetch departments");

    const result = await response.json();
    setDepartments(result);
    setLoading(false);
  } catch (error) {
    console.error("Error fetching data:", error);
    setLoading(false);
  }
};
  

  if (loading) {
    return <h2 className="text-center">Loading...</h2>;
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    let response;
    if (editId) {
      response = await fetch(`https://backend.sanchalansetu.com/api/v1/departments/edit/${editId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
        body: JSON.stringify({ name: formData.name }),
      });
    } else {
      response = await fetch("https://backend.sanchalansetu.com/api/v1/departments/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
        body: JSON.stringify({ name: formData.name }),
      });
    }

    if (!response.ok) {
      throw new Error("Failed to save department");
    }
    await fetchDepartments();
    

    
    setFormData({ name: "" });
    setEditId(null);

  } catch (error) {
    console.error("Error saving department:", error);
  }
};

  const handleEdit = (id) => {
    const departmentToEdit = Departments.find((d) => d.id === id);
    if (departmentToEdit) {
      setFormData({
        name: departmentToEdit.name,
      });
      setEditId(id);
    }
  };

  const cancelEdit = () => {
    setFormData({ name: "" });
    setEditId(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    if (itemToDelete !== null) {
      try {
        const response = await fetch(`https://backend.sanchalansetu.com/api/v1/departments/delete/${itemToDelete}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${Auth}`,
          },
        });
        if (!response.ok) throw new Error("Failed to delete department");

        
        await fetchDepartments();

        setDeleteModalShow(false);
        setItemToDelete(null);
      } catch (error) {
        console.error("Error deleting department:", error);
      }
    }
  };


  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  return (
    <div className=" role-settings-container">
      
      <div className="bg-white p-[1vw]  role-settings-form-container">
        <div className="text-[20px] font-bold border-b-1 text-gray-600 border-gray-300 pb-[2px]">
          <h1 className="text-gray-600">
            {editId ? "Update Department Settings" : "Add Department Settings"}
          </h1>
        </div>
        <form className="bg-white pt-1 rounded-lg" onSubmit={handleSubmit}>
          
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Department Name *
            </label>
            <input
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter Department Name"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          

          <div className="flex items-center gap-2">
            <button
              type="submit"
              className="bg-blue-500 text-sm hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              {editId ? "Update" : "Save"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={cancelEdit}
                className="bg-gray-500 text-sm hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      
      <ul className="w-full role-settings-display-container">
        <li className="bg-white p-[1vw]">
          <div className="text-[20px] font-bold pb-[10px]">
            <h1>Department List</h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-4">
                        
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-left">#</div>
                        </th>
                        <th className="pr-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-left">Department Name</div>
                        </th>
                        
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-center">Action</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {Departments.length > 0 ? (
                        Departments.map((item, index) => (
                          <tr className="grid grid-cols-4" key={item.id}>
                            <td className="px-4 py-2 whitespace-nowrap">
                              <div className={`text-left font-medium text-gray-800 ${
                                isSidebarCollapsed ? "text-base" : "text-sm"
                              }`}>
                                {index + 1}
                              </div>
                            </td>

                            <td className="pr-4 py-2 whitespace-nowrap">
                              <div className={`text-left text-gray-800 ${
                                isSidebarCollapsed ? "text-base" : "text-sm"
                              }`}>
                                {item.name || "N/A"}
                              </div>
                            </td>

                            <td className="px-4 py-2 whitespace-nowrap">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(item.id)}
                                  className={`text-blue-500 hover:text-blue-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Edit"
                                >
                                  <TbEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(item.id)}
                                  className={`text-red-500 hover:text-red-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Delete"
                                >
                                  <MdDeleteOutline />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="p-2 text-center">
                            No Department added yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>
        
      </ul>

      
      {deleteModalShow && (
        <DeleteModal
          itemName={Departments.find((d) => d.id === itemToDelete)?.name || "Department"}
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
    </div>
  );
};

export default Department;
